export const getVatPercentage = (pricePerMonthVatExclusive: number, pricePerMonthVatInclusive: number) => {
  return Math.round(((pricePerMonthVatInclusive - pricePerMonthVatExclusive) / pricePerMonthVatExclusive) * 100);
};
